import { useCallback, useEffect, useState } from "react";
import ExtUserPaymentHistoryService from "../../../../services/accounts/externalUserPaymentHistory";
import { NavigateFunction, useNavigate } from "react-router-dom";

export const useFetchYears = (accountNumber: number) => {
  const navigate: NavigateFunction = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [data, setData] = useState<number[]>([]);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await ExtUserPaymentHistoryService.fetchYears(accountNumber);
      setData(res);
      setIsLoading(false);
    } catch (e: any) {
      const data = e.response.data;
      data.status === 400 && navigate("/not-found");
      setIsLoading(false);
    }
  }, [accountNumber, navigate, setData, setIsLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading };
};
